import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Trash2, XCircle, Loader } from 'lucide-react';
import { useConfirmDeleteAccount } from '@/hooks/useApi';
import { useAuthStore } from '@/store';

export default function DeleteAccountPage() {
  const [searchParams]  = useSearchParams();
  const token           = searchParams.get('token') ?? '';
  const { mutate: confirmDelete } = useConfirmDeleteAccount();
  const logout          = useAuthStore((state) => state.logout);
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');

  useEffect(() => {
    if (!token) { setStatus('error'); return; }
    confirmDelete(token, {
      onSuccess: () => {
        logout();
        setStatus('success');
      },
      onError: () => setStatus('error'),
    });
  }, [token]);

  return (
    <div className="min-h-screen bg-white dark:bg-zinc-900 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-zinc-900 rounded-2xl shadow-sm border border-gray-200 dark:border-zinc-800 p-8 max-w-md w-full text-center">
        {status === 'loading' && (
          <>
            <Loader className="h-12 w-12 text-brand-500 animate-spin mx-auto mb-4" />
            <h1 className="text-xl font-bold text-gray-900 dark:text-zinc-100">Deleting your account…</h1>
          </>
        )}
        {status === 'success' && (
          <>
            <Trash2 className="h-12 w-12 text-red-400 mx-auto mb-4" />
            <h1 className="text-xl font-bold text-gray-900 dark:text-zinc-100 mb-2">Account deleted</h1>
            <p className="text-gray-500 dark:text-zinc-500 mb-6">Your account and all associated data has been permanently removed.</p>
            <Link to="/" className="btn-primary px-6 py-2">Go to homepage</Link>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle className="h-12 w-12 text-red-400 mx-auto mb-4" />
            <h1 className="text-xl font-bold text-gray-900 dark:text-zinc-100 mb-2">Link invalid or expired</h1>
            <p className="text-gray-500 dark:text-zinc-500 mb-6">This deletion link has expired or already been used. Request a new one from Settings.</p>
            <Link to="/settings" className="btn-primary px-6 py-2">Go to Settings</Link>
          </>
        )}
      </div>
    </div>
  );
}
